// extracted by mini-css-extract-plugin
export default {"BaseContent":"BaseContent_BaseContent__GZEgy"};